/* ORZO: kalkulator imprezy na /pages/eventy (sections/eventy-oferta.liquid, #kalkulator).
   Cztery kroki: lokal, liczba gości, menu, napoje. Ceny i serwis tylko z danych
   (orzo_pakiet, orzo_set_napojow), zaliczka z ustawień sekcji.
   Adres może ustawić kroki: ?lokal=, ?osoby=, ?menu= (albo ?pakiet=), ?set=.
   „Wyślij zapytanie z tą wyceną” wypełnia formularz #OrzoEventContact. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var kk = $('[data-ev-kk]');
  var daneEl = $('[data-kk-dane]');
  if (!kk || !daneEl) return;

  var dane = {}, T = {};
  try { dane = JSON.parse(daneEl.textContent); } catch (e) { return; }
  try { T = JSON.parse(($('[data-kk-t]') || {}).textContent || '{}'); } catch (e) { T = {}; }
  var tt = function (k, o, zapas) {
    return String(T[k] || zapas || '').replace(/\{(\w+)\}/g, function (_, x) { return o && o[x] != null ? o[x] : ''; });
  };
  var NF = new Intl.NumberFormat(document.documentElement.lang || 'pl', { maximumFractionDigits: 0 });
  var zl = function (n) { return NF.format(Math.round(n)) + ' zł'; };
  var TYP_MENU = { swieta: 'Wigilia firmowa', komunia: 'Przyjęcie komunijne' };

  var suwak = $('[data-kk-suwak]', kk), liczba = $('[data-kk-goscie]', kk);
  var salaEl = $('[data-kk-sala]', kk), napojeWMenu = $('[data-kk-napoje-w-menu]', kk);
  var wycena = $('[data-kk-wycena]'), sumaEl = $('[data-kk-suma]'), osEl = $('[data-kk-os]');
  var rozbicie = $('[data-kk-rozbicie]'), rozwin = $('[data-kk-rozwin]'), wyslij = $('[data-kk-wyslij]');
  var ostatni = null;

  var wybrane = function (nazwa) { var r = $('input[name="' + nazwa + '"]:checked', kk); return r ? r.value : ''; };
  var zaznacz = function (nazwa, wartosc) {
    var r = $$('input[name="' + nazwa + '"]', kk).find(function (x) { return x.value === wartosc; });
    if (r && !r.disabled) { r.checked = true; return true; }
    return false;
  };
  var cenaMenu = function (lok, m) { return (lok && lok.prog === 'B' && m.b) ? m.b : m.a; };
  var jednostka = function (m) { return tt(m.jedn === 'brutto' ? 'brutto' : 'netto', null, m.jedn); };

  function przelicz() {
    var lok = (dane.lokale || {})[wybrane('lokal')];
    var mh = wybrane('menu');
    var m = (dane.menu || {})[mh];
    var g = Math.max(1, Math.min(999, parseInt(liczba.value, 10) || 0));
    if (!lok || !m) return;

    /* ceny menu na kaflach wg progu cenowego wybranego lokalu */
    Object.keys(dane.menu || {}).forEach(function (h) {
      var el = $('[data-kk-cena="' + h + '"]', kk);
      var x = dane.menu[h];
      if (el) el.textContent = zl(cenaMenu(lok, x)) + ' ' + jednostka(x) + tt('pp', null, '/os.');
    });

    /* napoje: tylko sety przypięte do menu; menu bez setów ma napoje w cenie */
    var dozwolone = m.sety || [];
    $$('[data-kk-set]', kk).forEach(function (lab) {
      var ok = dozwolone.indexOf(lab.dataset.kkSet) !== -1;
      lab.hidden = !ok;
      var r = $('input', lab); r.disabled = !ok;
      if (!ok && r.checked) zaznacz('set', '');
    });
    if (napojeWMenu) napojeWMenu.hidden = dozwolone.length > 0;
    var set = (dane.sety || {})[wybrane('set')];

    var cena = cenaMenu(lok, m);
    var zaMenu = cena * g;
    var zaNapoje = set ? set.cena * g : 0;
    var serwis = m.serwis ? (zaMenu + zaNapoje) * m.serwis / 100 : 0;
    var razem = zaMenu + zaNapoje + serwis;
    var naOsobe = razem / g;
    var procZal = +dane.zaliczka || 0;
    var zaliczka = zaMenu * procZal / 100;
    var jedn = jednostka(m);

    var wiersze = [[tt('menu', null, 'Menu'), g + ' × ' + zl(cena), zl(zaMenu)]];
    if (set) wiersze.push([tt('napoje', { set: set.nazwa }, set.nazwa), g + ' × ' + zl(set.cena), zl(zaNapoje)]);
    if (serwis) wiersze.push([tt('serwis', { n: String(m.serwis).replace('.', ',') }, m.serwis + '%'), '', zl(serwis)]);
    wiersze.push([tt('razem', null, 'Razem') + ' ' + jedn, '', zl(razem), 'suma']);
    if (m.jedn !== 'brutto') wiersze.push([tt('brutto_brak'), '', '', 'uwaga']);
    if (procZal) wiersze.push([tt('zaliczka', { n: procZal }), '', zl(zaliczka)]);
    rozbicie.innerHTML = '';
    wiersze.forEach(function (w) {
      var d = document.createElement('div');
      if (w[3]) d.className = 'ev-kk-w-' + w[3];
      var dt = document.createElement('dt'); dt.textContent = w[0];
      var dd = document.createElement('dd');
      if (w[1]) { var s1 = document.createElement('span'); s1.textContent = w[1]; dd.appendChild(s1); }
      if (w[2]) { var s2 = document.createElement('b'); s2.textContent = w[2]; dd.appendChild(s2); }
      d.appendChild(dt); d.appendChild(dd); rozbicie.appendChild(d);
    });
    sumaEl.textContent = zl(razem) + ' ' + jedn;
    osEl.textContent = zl(naOsobe) + ' ' + tt('na_osobe', null, '/os.');

    var pasuje = (lok.sale || []).filter(function (s) { return s.p >= g; }).sort(function (a, b) { return a.p - b.p; })[0];
    var max = Math.max.apply(null, (lok.sale || []).map(function (s) { return s.p; }).concat([0]));
    salaEl.textContent = pasuje
      ? tt(pasuje.caly ? 'caly' : 'sala', { lokal: lok.nazwa, sala: pasuje.n, n: pasuje.p })
      : (max ? tt('brak', { lokal: lok.nazwa, n: max }) : '');

    ostatni = { lokH: wybrane('lokal'), lok: lok, g: g, m: m, set: set, razem: razem, naOsobe: naOsobe, serwis: serwis, zaliczka: zaliczka, jedn: jedn, sala: pasuje };
  }

  /* suwak i pole liczby gości trzymają tę samą wartość */
  suwak.addEventListener('input', function () { liczba.value = suwak.value; przelicz(); });
  liczba.addEventListener('input', function () {
    var v = parseInt(liczba.value, 10);
    if (v) suwak.value = Math.max(+suwak.min, Math.min(+suwak.max, v));
    przelicz();
  });
  kk.addEventListener('change', przelicz);
  kk.addEventListener('submit', function (e) { e.preventDefault(); });

  /* start z adresu */
  var par = new URLSearchParams(location.search);
  if (par.get('lokal')) zaznacz('lokal', par.get('lokal'));
  else { try { var ul = localStorage.getItem('orzo.preferredVenue'); if (ul) zaznacz('lokal', ul); } catch (e) {} }
  var os = parseInt(par.get('osoby'), 10);
  if (os > 0) { liczba.value = os; suwak.value = Math.max(+suwak.min, Math.min(+suwak.max, os)); }
  var pm = par.get('menu') || par.get('pakiet');
  if (pm) zaznacz('menu', pm);
  else {
    var typ = (par.get('typ') || '').toLowerCase();
    var szukaj = /wigilia/.test(typ) ? 'swieta' : (/komunia|komunijne/.test(typ) ? 'komunia' : '');
    if (szukaj) Object.keys(dane.menu || {}).some(function (h) { return dane.menu[h].typ === szukaj && zaznacz('menu', h); });
  }
  przelicz();
  if (par.get('set')) { zaznacz('set', par.get('set')); przelicz(); }

  /* linki „policz” z zakładek okazji ustawiają menu danego typu */
  $$('a[data-kalk]').forEach(function (a) {
    a.addEventListener('click', function () {
      var t = a.dataset.kalk;
      Object.keys(dane.menu || {}).some(function (h) { return dane.menu[h].typ === t && zaznacz('menu', h); });
      przelicz();
    });
  });

  /* szczegóły wyceny na telefonie: zwinięte, żeby pasek nie zasłaniał kroków */
  if (rozwin && wycena) rozwin.addEventListener('click', function () {
    var otwarte = rozwin.getAttribute('aria-expanded') === 'true';
    rozwin.setAttribute('aria-expanded', String(!otwarte));
    wycena.classList.toggle('is-otwarta', !otwarte);
    rozwin.textContent = tt(otwarte ? 'szczegoly' : 'ukryj', null, rozwin.textContent);
  });

  /* przejście do formularza zapytania z wyceną */
  if (wyslij) wyslij.addEventListener('click', function (e) {
    var form = $('#OrzoEventContact');
    if (!ostatni || !form) return;
    e.preventDefault();
    var venue = $('[data-event-venue]', form);
    if (venue) {
      var o = $$('option', venue).find(function (x) { return x.dataset.handle === ostatni.lokH; });
      if (o) { venue.value = o.value; venue.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var gi = $('input[name="contact[Liczba gości]"]', form);
    if (gi) gi.value = ostatni.g;
    var typSel = $('[data-event-type]', form), typ = TYP_MENU[ostatni.m.typ];
    if (typSel && typ) {
      var ot = $$('option', typSel).find(function (x) { return x.value === typ; });
      if (ot) { typSel.value = ot.value; typSel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var notka = tt('notka', {
      lokal: ostatni.lok.nazwa,
      menu: ostatni.m.nazwa,
      set: ostatni.set ? ', ' + ostatni.set.nazwa : '',
      g: ostatni.g,
      os: zl(ostatni.naOsobe),
      suma: zl(ostatni.razem),
      jedn: ostatni.jedn,
      serwis: ostatni.serwis ? ' (' + tt('serwis', { n: String(ostatni.m.serwis).replace('.', ',') }) + ')' : '',
      zaliczka: zl(ostatni.zaliczka),
      sala: ostatni.sala ? ' ' + ostatni.sala.n + '.' : ''
    }, '[Kalkulator] ' + ostatni.m.nazwa + ', ' + ostatni.g + ', ' + zl(ostatni.razem));
    var t = $('textarea[name="contact[body]"]', form);
    if (t) {
      var baza = t.value.replace(/\n*\[(Kalkulator|Calculator)\][\s\S]*$/, '');
      t.value = baza ? baza + '\n\n' + notka : notka;
    }
    var cel = $('#zapytanie');
    if (cel) cel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var imie = $('input[name="contact[name]"]', form);
    if (imie) setTimeout(function () { imie.focus({ preventScroll: true }); }, 500);
  });
}());
